import O1HD from "../../engines/gameEngine";
import { SPEND_MODE_EVENT } from "./config/SpendEnum";

const {ccclass, property} = cc._decorator;

@ccclass
export default class InteroperableObj extends cc.Component {

    onLoad(){
        O1HD.on(SPEND_MODE_EVENT.SPEND_OBJ_INIT,this.initObj,this)
    }

    initObj(){}
    
}
